
import { createClient } from '@supabase/supabase-js';

/**
 * Ache em Guarulhos - Supabase Client Configuration
 * Alterado para importação padrão de pacote para compatibilidade com o build (tsc).
 */

const DEFAULT_URL = 'https://dlutyraamgcelrzaxfix.supabase.co';
const DEFAULT_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRsdXR5cmFhbWdjZWxyemF4Zml4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkyNjA5ODUsImV4cCI6MjA4NDgzNjk4NX0.3lidO_4TpDlim16En60uJm010BdfF-5PmLxYtmvvCwg';

const getEnvValue = (key: string): string | undefined => {
  try {
    if (typeof process !== 'undefined' && process.env && process.env[key]) {
      return process.env[key];
    }
    if (typeof window !== 'undefined' && (window as any).process?.env?.[key]) {
      return (window as any).process.env[key];
    }
    return undefined;
  } catch (e) {
    return undefined;
  }
};

const supabaseUrl = getEnvValue('SUPABASE_URL') || DEFAULT_URL;
const supabaseAnonKey = getEnvValue('SUPABASE_ANON_KEY') || DEFAULT_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
